import React, { useState } from 'react';
import Footer from './Footer';
import Navbar from './Navbar';
import Ummahfy from './Ummahfy.svg';

const Redirect = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUrl = urlParams.get('url').split('?')[0];

    const openExternalBrowser = () => {
        if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
            window.location.href = "x-safari-" + redirectUrl;
        } else if (/Android/.test(navigator.userAgent)) {
            window.location.href = `intent:${redirectUrl.replace('https://', '')}#Intent;` +
                `scheme=https;` +
                `package=com.android.chrome;` +
                `S.browser_fallback_url=${encodeURIComponent(redirectUrl)};` +
                `end`;
        } else {
            window.location.href = redirectUrl;
        }

    };

    return (
        <>
            <div className="wrapper">
                <Navbar />
                <div className="redirect-container">
                    <p class="title"> right idea,</p>
                    <p class="title"> wrong browser</p>
                    <img className="redirect-img" src={Ummahfy} alt="Redirect" />
                    <p class="subtext"> Google doesn't allow signing in from within Instagram. Please switch to your default browser to sign in. </p>
                    <button className="join" onClick={() => openExternalBrowser()}>Open in Browser</button>
                </div>
            </div>
            <Footer />
        </>
    );

};

export default Redirect;